import { render, staticRenderFns } from "./SoMessage.vue?vue&type=template&id=aca242e0&scoped=true&"
import script from "./SoMessage.vue?vue&type=script&lang=js&"
export * from "./SoMessage.vue?vue&type=script&lang=js&"
import style0 from "./SoMessage.vue?vue&type=style&index=0&id=aca242e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aca242e0",
  null
  
)

export default component.exports